'use client'

import { usePathname } from 'next/navigation'
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  type ReactNode,
} from 'react'

const medicineListRoot = '/prescriptions-online/categories'

function isMedicineListPath(pathname: string | null) {
  if (!pathname?.startsWith(medicineListRoot)) return false

  const remainder = pathname.slice(medicineListRoot.length)
  const segments = remainder.split('/').filter(Boolean)

  return segments.length <= 1
}

const MedicineQuizMotionContext = createContext(true)

export function MedicineQuizMotionBoundary({
  children,
}: {
  children: ReactNode
}) {
  const pathname = usePathname()
  const previousPathname = useRef<string | null>(null)

  const animateSharedChrome = useMemo(
    () =>
      isMedicineListPath(pathname) &&
      !isMedicineListPath(previousPathname.current),
    [pathname],
  )

  useEffect(() => {
    previousPathname.current = pathname
  }, [pathname])

  return (
    <div className="min-h-screen min-h-[100dvh] bg-white">
      <MedicineQuizMotionContext.Provider value={animateSharedChrome}>
        {children}
      </MedicineQuizMotionContext.Provider>
    </div>
  )
}

export function useAnimateMedicineQuizChrome() {
  return useContext(MedicineQuizMotionContext)
}
